/* eslint-disable */
import { OasLangParam, OasLanguage } from './types';

export const LOCALE__PATH: OasLangParam = ':locale(no|en|uk)';
export const LOCALE__REGEXP = /:locale\(no\|en\|uk\)/gs;

export const DEFAULT_LOCALE: OasLanguage = 'no';
